// extracted by mini-css-extract-plugin
export var content = "_o5-1";
export var fullScreen = "_o5-0";